import { render, staticRenderFns } from "./MobilePreRecordPage.vue?vue&type=template&id=5661db22&scoped=true&"
import script from "./MobilePreRecordPage.vue?vue&type=script&lang=js&"
export * from "./MobilePreRecordPage.vue?vue&type=script&lang=js&"
import style0 from "./MobilePreRecordPage.vue?vue&type=style&index=0&id=5661db22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5661db22",
  null
  
)

export default component.exports